document.addEventListener('DOMContentLoaded', function() {
    window.initLazyLoading = function() {
        const lazyImages = document.querySelectorAll('img.lazy');
        const lazyVideos = document.querySelectorAll('video.lazy');
    
        const lazyLoad = (target) => {
            if (target.tagName === 'IMG') {
                target.src = target.dataset.src;
                target.onload = () => target.classList.add('loaded');
            } else if (target.tagName === 'VIDEO') {
                if (target.dataset.poster) {
                    target.poster = target.dataset.poster;
                }

                let firstSrc;

                target.querySelectorAll('source').forEach(source => {
                    if (source.tagName !== 'SOURCE' || !source.dataset.src) return;

                    source.src = source.dataset.src;
                    if (!firstSrc) firstSrc = source.src;
                    source.onload = () => source.classList.add('loaded');
                });

                if (target.dataset.src) {
                    target.src = target.dataset.src;
                } else if (firstSrc) {
                    target.src = firstSrc;
                };

                target.load();
                target.onloadeddata = () => {
                    target.classList.add('loaded');
                    target.play();
                };
            }
            target.classList.remove('lazy');
        };
    
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        lazyLoad(entry.target);
                        observer.unobserve(entry.target);
                    }
                });
            });

            lazyImages.forEach(image => observer.observe(image));
            lazyVideos.forEach(video => observer.observe(video));
        } else {
            lazyImages.forEach(image => lazyLoad(image));
            lazyVideos.forEach(video => lazyLoad(video));
        }
    
        // const layoutMobile = document.querySelectorAll('.layout_mobile');
        // const layoutDesktop = document.querySelectorAll('.layout_desktop');
        // if (window.innerWidth > 768) layoutMobile.forEach(element => element.remove());
        // if (window.innerWidth < 769) layoutDesktop.forEach(element => element.remove());
    };

    window.initLazyLoading();
});
